import { Component, OnInit } from "@angular/core";

@Component({
    selector: "ngx-terms",
    template: `<ngx-one-column-layout>
        <router-outlet></router-outlet>
    </ngx-one-column-layout>`,
    styleUrls: ["./terms.component.scss"],
})
export class TermsLayoutComponent implements OnInit {
    ngOnInit(): void {}
}
